import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "@/types/index";
import { login } from "@/store/login";
import { auth } from "@/store/auth";
import { user } from "@/store/user";
import { sales } from "@/store/sales";
import { error } from "@/store/error";
import { member } from "@/store/member";
import { company } from "@/store/company";
import { ticket } from "@/store/ticket";
import { partner } from "@/store/partner";
import { staff } from "@/store/staff";
import { tag } from "@/store/tag";
import { skill } from "@/store/skill";
import { department } from "@/store/department";
import { employment } from "@/store/employment";
import { status } from "@/store/status";
import { proposal } from "@/store/proposal";
import { proposalStatus } from "@/store/proposalStatus";
import { post } from "@/store/post";
import { channel } from "@/store/channel";
import { offer } from "@/store/offer";
import { offerStatus } from "@/store/offerStatus";
import { progress } from "@/store/progress";
import { proceed } from "@/store/proceed";
import { alertcondition } from "@/store/alertcondition";
import { alert } from "@/store/alert";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0",
    loadingCount: 0,
  },
  mutations: {
    loadingError: (state) => {
      state.loadingCount = 0;
    },
    loadingIncrement: (state) => {
      state.loadingCount++;
    },
    loadingDecrement: (state) => {
      state.loadingCount--;
    },
  },
  actions: {},
  getters: {
    isLoading: (state) => state.loadingCount > 0,
  },
  modules: {
    login,
    auth,
    user,
    sales,
    error,
    member,
    company,
    ticket,
    partner,
    staff,
    tag,
    skill,
    department,
    employment,
    status,
    proposal,
    proposalStatus,
    post,
    channel,
    offer,
    offerStatus,
    progress,
    proceed,
    alertcondition,
    alert,
  },
};

export default new Vuex.Store<RootState>(store);
// ({
// state: {},
// actions: {},
// modules: {
//   login,
// },
// });
